const route = [
    {
        path: '/communication/noticelist',
        component: function (resolve) {
            require(['VIEWS/communication/noticeList.vue'], resolve);
        },
    },
    {
        path: '/communication/sfsms',
        component: function (resolve) {
            require(['VIEWS/communication/sfsms.vue'], resolve);
        },
    },
    {
        path: '/communication/sfrecord',
        component: function (resolve) {
            require(['VIEWS/communication/sfrecord.vue'], resolve);
        },
    },
];
export default route
